
(function() {
  var result = { translations: { "af": { "i18n": { "duration": { "seconds": "{{ seconds }} sekondes", "minutes": "{{ minutes }} minute", "hours": "{{ hours }} ure", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dae ", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u{{ minutes }}m" } }, "dateTime": { "quarterAndYear": "{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, uitbr. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "af": "static-7.1088"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1088",
    "ar-eg": "static-7.1088",
    "bg": "static-7.1088",
    "bn": "static-7.1088",
    "ca-es": "static-7.1088",
    "cs": "static-7.1088",
    "da": "static-7.1088",
    "de": "static-7.1088",
    "el": "static-7.1088",
    "en-gb": "static-7.1088",
    "en": "static-7.1088",
    "es-mx": "static-7.1088",
    "es": "static-7.1088",
    "et": "static-7.1088",
    "fi": "static-7.1088",
    "fr-ca": "static-7.1088",
    "fr": "static-7.1088",
    "he-il": "static-7.1088",
    "hi": "static-7.1088",
    "hr": "static-7.1088",
    "hu": "static-7.1088",
    "id": "static-7.1088",
    "it": "static-7.1088",
    "ja": "static-7.1088",
    "ko": "static-7.1088",
    "lt": "static-7.1088",
    "ms": "static-7.1088",
    "nl": "static-7.1088",
    "no": "static-7.1088",
    "pl": "static-7.1088",
    "pt-br": "static-7.1088",
    "pt-pt": "static-7.1088",
    "ro": "static-7.1088",
    "ru": "static-7.1088",
    "sk": "static-7.1088",
    "sl": "static-7.1088",
    "sv": "static-7.1088",
    "th": "static-7.1088",
    "tl": "static-7.1088",
    "tr": "static-7.1088",
    "uk": "static-7.1088",
    "vi": "static-7.1088",
    "x-pseudo": "static-7.1088",
    "zh-cn": "static-7.1088",
    "zh-hk": "static-7.1088",
    "zh-tw": "static-7.1088"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:af', {version: 'static-7.1088'}); }
})();


